module.exports = __webpack_public_path__ + "img/Mask Group2@2x.cfe899d9.png";